export const COLOR = {
  MONA_LISA: '#FF928E',
  TEMPERATURE: '#ff736f',
  PAPRIKA: '#ff736f',
  OLIVER: '#a1c862',
  CHAMPAGNE: '#ffb7b5',
  OLLE: '#c9dd84',
  MILK_CHOCOLATE: '#e8d2c6',
  TABASCO: '#D83030',
  CHOLULA: '#E7483F',
  HABANERO: '#F9584F',
  LH: '#8dbeff',
  PREGNANT: '#63A4F8',
  WHITE: '#ffffff',
  BLACK: '#1a1a1a',
  GRAY: '#a3a3a3',
  LIGHT_GRAY: '#f5f3f3',
  MEDIUM_GRAY: '#f1eaea',
  MEDIUM: '#e2d4d4',
  PURPLE: '#72035d',
  DARK_PURPLE: '#560246',
  SATSUMA: '#ff9000',
  PINK: '#fa837f',
  BLEEDING: '#D294EF',
  CERVICAL_MUCUS: '#F196E7',
  PAIN: '#FF9A75',
  SKIN: '#ff928e',
  LIFESTYLE: '#a6d1a6',
  EXTERNAL_FACTOR: '#ffb800',
  MOOD: '#FFDF5C',
  SEX: '#FD90B4',
  SLEEP: '#abb1d2',
  PREDICTION: '#757575',
  HIDDEN_FERTILITY_STATUS: '#1a1a1a',
  RECOVERY: '#D294EF',
  GHOST: '#f1eaea',
  ACCENT: '#ffd7d6',
  SAPHIRE_PINK: '#897184',
  AUBERGINE_PURPLE: '#300629',
  BREASTFEEDING: '#ffcdd3',
  BOTTLE_FEEDING: '#72d6c4',
  PUMPING: '#ffb800',
  SECONDARY_DARK: '#F796EE',
  DARK_SHADE: '#7FB7FF',
  DARK_BACKGROUND: '#4a2d47',
  DARK_ALERT: '#FF7C7C',
}

export const HEX_OPACITY = {
  100: 'FF',
  99: 'FC',
  98: 'FA',
  97: 'F7',
  96: 'F5',
  95: 'F2',
  94: 'F0',
  93: 'ED',
  92: 'EB',
  91: 'E8',
  90: 'E6',
  89: 'E3',
  88: 'E0',
  87: 'DE',
  86: 'DB',
  85: 'D9',
  84: 'D6',
  83: 'D4',
  82: 'D1',
  81: 'CF',
  80: 'CC',
  79: 'C9',
  78: 'C7',
  77: 'C4',
  76: 'C2',
  75: 'BF',
  74: 'BD',
  73: 'BA',
  72: 'B8',
  71: 'B5',
  70: 'B3',
  69: 'B0',
  68: 'AD',
  67: 'AB',
  66: 'A8',
  65: 'A6',
  64: 'A3',
  63: 'A1',
  62: '9E',
  61: '9C',
  60: '99',
  59: '96',
  58: '94',
  57: '91',
  56: '8F',
  55: '8C',
  54: '8A',
  53: '87',
  52: '85',
  51: '82',
  50: '80',
  49: '7D',
  48: '7A',
  47: '78',
  46: '75',
  45: '73',
  44: '70',
  43: '6E',
  42: '6B',
  41: '69',
  40: '66',
  39: '63',
  38: '61',
  37: '5E',
  36: '5C',
  35: '59',
  34: '57',
  33: '54',
  32: '52',
  31: '4F',
  30: '4D',
  29: '4A',
  28: '47',
  27: '45',
  26: '42',
  25: '40',
  24: '3D',
  23: '3B',
  22: '38',
  21: '36',
  20: '33',
  19: '30',
  18: '2E',
  17: '2B',
  16: '29',
  15: '26',
  14: '24',
  13: '21',
  12: '1F',
  11: '1C',
  10: '1A',
  9: '17',
  8: '14',
  7: '12',
  6: '0F',
  5: '0D',
  4: '0A',
  3: '08',
  2: '05',
  1: '03',
  0: '00',
}
